module.exports = __webpack_public_path__ + "media/images/gallery/constellations/aquarius/aqr_gc-bc61f32c26e049a84e7ecbcecf9145ae.gif";